import React from 'react';

export interface NewTabLinkProps extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {};

export const NewTabLink: React.FC<NewTabLinkProps> = (props) => (
    <a target="_blank" rel="noopener noreferrer" {...props}>{props.children}</a>
);

(NewTabLink as any).displayName = 'NewTabLink';